export default "__VITE_ASSET__kHsbt_cN__"